const isUnAuth = (status) => status && (status === 401);

export default isUnAuth;
